// ****************************** Import From AWS Amplify ******************************** //

import '/src/amplify-config';

// ****************************** Import CSS ******************************** //

import "./index.css";

//****************************** Spinner Image *************************//

import "/src/assets/fp-icons/fp-circular-favicon.png";

// ****************************** Import Images ******************************** //

import "/src/assets/gcs-logos/gcs-wordmark-black.png";

import "/src/assets/box-designs/cake-pop-checked-sm.png";

import "/src/assets/box-designs/cake-pop-checked.png";

import "/src/assets/fp-icons/fp-box-icon.png";

// ****************************** Import Hero Images ******************************** //

import "/src/assets/images/carmen-chair-3201.jpg";
import "/src/assets/images/carmen-chair-3241.jpg";
import "/src/assets/images/carmen-mentor-3260.jpg";
import "/src/assets/images/carmen-foils-hair-3035.jpg";
import "/src/assets/images/carmen-foils-hair-3053.jpg";
import "/src/assets/images/carmen-foils-hair-3062.jpg";
import "/src/assets/images/carmen-foils-hair-3063.jpg";
import "/src/assets/images/carmen-foils-hair-3071.jpg";
import "/src/assets/images/carmen-foils-hair-3073.jpg";
import "/src/assets/images/carmen-foils-hair-3037.jpg";
import "/src/assets/images/fp-box-3028.jpg";
import "/src/assets/images/fp-box-2997.jpg";
import "/src/assets/images/foils-hair-3014.jpg";

// ****************************** Import Product Gallery ******************************** //

import "/src/assets/images/arrow.svg";

import "/src/assets/images/fp-foils-in-hair-at-sink.jpg";
import "/src/assets/videos/fp-video-footage1.mp4";
import "/src/assets/images/foiled-pretty-stacked-boxes.jpg";

import "/src/assets/images/fp-box-gold-dresses.png";
import "/src/assets/images/fp-shipping-box-side.png";
import "/src/assets/images/fp-giveaway.jpeg";
import "/src/assets/images/fp-coming-soon-page.png";
import "/src/assets/images/carmen-mentor-3260.jpg";
import "/src/assets/images/fp-box-face-color.png";
import "/src/assets/images/fp-box-fp-tape.jpg";
import "/src/assets/images/fp-box-under-cmas-tree.png";

import "/src/assets/images/foils-hair-3154.jpg";
import "/src/assets/images/get-foiled-trucker-hat.png";
import "/src/assets/images/wearing-get-foiled-hat.png";
import "/src/assets/images/stacked-boxes-3269.jpg";

import "/src/assets/images/video-1-poster.png";
import "/src/assets/images/swipe-arrow.svg";

// *************************** Import Product Info Images ***************************** //

import "/src/assets/images/foils-hair-3020.jpg";
import "/src/assets/images/client-dryer-3292.jpg";
import "/src/assets/images/foils-hair-3111.jpg";
import "/src/assets/images/foils-hair-3186.jpg";
import "/src/assets/images/fp-box-3028.jpg";

// **************************** Add Top Nav & Footer ************************** //

import './nav-header-footer/nav-header-footer.js';
import './nav-header-footer/nav-header-footer.css';

// ************ Add Email Signup Form *************** //

import './nav-header-footer/email-signup-form.js';

// **************************** Spinner ****************************** //

// $(window).on('load', function(){
//   document.getElementById("spinner").style.display = "block";
//   setTimeout(removeSpinner, 1000);
// });

// function removeSpinner(){
//   $( "#spinner").fadeOut(100, function() {
//     $( "#spinner").remove();
//   });
// }

// ****************************** JS - Product Gallery ******************************** //

const productContainers = [...document.querySelectorAll('.gallery-slider')];

const nxtBtn = [...document.querySelectorAll('.nxt-btn')];
const preBtn = [...document.querySelectorAll('.pre-btn')];

productContainers.forEach((item, i) => {

    let containerDimensions = item.getBoundingClientRect();
    let containerWidth = containerDimensions.width;

    const viewportWidth = window.innerWidth;
    //console.log(`Viewport Width: ${viewportWidth}px`);

    //console.log("Container Width: ", containerWidth);

    nxtBtn[i].addEventListener('click', () => {
        item.scrollLeft += 400;
        console.log("Scrolling left");
    })

    preBtn[i].addEventListener('click', () => {
        item.scrollLeft -= 400;
        console.log("Scrolling right");
    })
})

// ****************************** JS - Customer Testimonials ******************************** //

const btns = document.querySelectorAll(".btn");
const slideRow = document.getElementById("slide-row");
const main = document.getElementById("testimonial-container");

let currentIndex = 0;

// *** Slide Testimonials *** //

function updateSlide() {
	const mainWidth = main.offsetWidth;
	const translateValue = currentIndex * -mainWidth;
	slideRow.style.transform = `translateX(${translateValue}px)`;

	btns.forEach((btn, index) => {
		btn.classList.toggle("active", index === currentIndex);
	});
}

// *** Testimonial Buttons *** //

btns.forEach((btn, index) => {
	btn.addEventListener("click", () => {
		currentIndex = index;
		updateSlide();
	});
});

// *** Resize Testimonials *** //

window.addEventListener("resize", () => {
	updateSlide();
});













